export default __webpack_public_path__ + "static/media/dashboard-templates.364a8b17.svg";